import React, { useState, useEffect } from 'react';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import CriteriaKeywords from './criteria-keywords';
import CriteriaRoomsPeople from './criteria-rooms-people';
import CriteriaDietaryTreatment from './criteria-dietary-treatment';
import CriteriaDateRange from './criteria-date-range'; 

import { useAppCtx } from './app-ctx';

{/* 
  <SearchForm />
    <CriteriaKeywords />
      <EditableSelect />
    <CriteriaRoomsPeople />
    <CriteriaDietaryTreatment />
    <CriteriaDateRange />
    <input type="submit" />
*/}

/**
 * 
 * @param {*} props 
 *  {
 *    searchCriterias = {
 *        keywords: string, 
 *        rooms: [ { adults: int, children: int, mealsAdult: int, mealsChildren: int }, ... ],
 *        dietaryOptions: [ int, int, ... ], // dietary option ids
 *        treatmentOptions: [ int, int, ... ], // treatment option ids
 *        checkInDate: string (YYYY-MM-DD),
 *        checkOutDate: string (YYYY-MM-DD)
 *    },
 *    diseasesHints   = [ "Cardiology", "Diabetes", "Dermatology", ... ]
 *    onLookup(searchCriterias) - callback when user clicks "Find a resort" button 
 *    onSearchCriteriasChange(searchCriterias) - callback when user changes any search criteria
 *  }
 * 
 * @returns 
 */
const SearchForm = (props) => {
  const { t, i18n } = useTranslation();
  const {JOOMLA_VARS, CONFIG, SearchDefaults} = useAppCtx();

  //=====TODO: get rid from this code, We defined search criterias into session
  let s = {
      keywords: null,
      occupacyValue: null,
      dietaryValue: null,
      dateRangeValue: null
  };


  // compute default check-in checkpout dayes 
  const today = new Date();
  const nextMondayDate = new Date(today.getTime() + (1 - today.getDay() + 7)*1000*60*60*24);
  const differenceInDays = Math.ceil(Math.abs(nextMondayDate - today.getTime()) / (1000 * 60 * 60 * 24));
  const checkInDate = differenceInDays <= 3
    ? new Date(nextMondayDate.setDate(nextMondayDate.getDate() + 7)) : nextMondayDate;
  const nextFriday = new Date(checkInDate);
  nextFriday.setDate(nextFriday.getDate() + 4);

  const dateRangeDefault = {
    checkInDate:checkInDate, checkOutDate: nextFriday
  };

  // setting defaults//
  s = {...s, occupacyValue: {adults: 2, children: 1}};
  s = {...s, dietaryValue: SearchDefaults.dietaryTreatmentSettings.dietaryOptions[0]};
  s = {...s, dateRangeValue: dateRangeDefault};
  //======= TODO end: get rid from this code, We defined search criterias into session

  const [searchCriterais, setSearchCriterais] = useState( s /*<== TODO: props.searchCriterias or without stare*/);

  console.log('SearchForm() Entry: props.searchCriterias.', JSON.stringify(props.searchCriterias));

  /** this is a reaction on 'Find a resort' button click */
  const handleSubmit = (event) => {
    event.preventDefault();
    if (props.onLookup) {
      props.onLookup(searchCriterais);
    } else {
      console.log('SearchForm().handleSubmit(): onLookup is not defined!');
    }
  };

  //TODO: remove in favor of container's onSearchCriteriasChange()
  const handleKeywordsChange = (newKeywords) => {
    console.log('SearchForm().handleKeywordsChange(): newKeywords=', newKeywords);
    let newCriteries = {...searchCriterais, keywords: newKeywords};
    setSearchCriterais( newCriteries );
  }
  const handleRoomsPeopleChange = (newOptions) => {
    console.log('SearchForm(). handleRoomsPeopleChange(): newOptions=', JSON.stringify(newOptions));
  }
  const handleOccupacyChange = (newOccupacyValue) => {
    console.log('SearchForm().handleOccupacyChange(): newOptions=', JSON.stringify(newOccupacyValue));
    let newCriteries = {...searchCriterais, occupacyValue: newOccupacyValue};
    setSearchCriterais( newCriteries );
  }
  const handleDietaryTreatmentChange = (newOptions) => {
    console.log('SearchForm().handleDietaryTreatmentChange(): newOptions=', JSON.stringify(newOptions));
    let newCriteries = {...searchCriterais, dietaryValue: newOptions};
    setSearchCriterais( newCriteries );
  }

  const handleDateRangeChange = (newOptions) => {
    console.log('SearchForm().handleDateRangeChange(): newOptions=', JSON.stringify(newOptions));
    let newCriteries = {...searchCriterais, dateRangeValue: newOptions};
    setSearchCriterais( newCriteries );
  }

  return (
    <form onSubmit={handleSubmit}>
      {/* Part 1: row ediable drop down which allows user to enter keywords */}
      <CriteriaKeywords className="form-element" 
          placeholder={t('Enter a City, Snanatorium, Country, Area, etc...')}
          searchHints={props.searchHints} label="name" 
          keywords={searchCriterais.keywords}
          onChange={handleKeywordsChange} 
         />
      
      {/* Part 2 shows number of rooms, number of people (adults/children ) and rolldonw arrow 
          +-------------------------------------------------------------+
          | rooms:1, adults: 2, children: 1                           V |
          +-------------------------------------------------------------+
      */}
      <CriteriaRoomsPeople className="form-element" 
        value={searchCriterais.occupacyValue}
        onChange={handleOccupacyChange}
      />
      {/* Part 3 Displays the selected dietary and treatment options
          +-------------------------------------------------------------+
          | 2 meals, with treatment                                   V |
          +-------------------------------------------------------------+
      */}
      <CriteriaDietaryTreatment className="form-element"
          {...SearchDefaults.dietaryTreatmentSettings}
          value={searchCriterais.dietaryValue}
          onChange={handleDietaryTreatmentChange}
      />

      {/* Part 4  Check-in and Check-out dates */} 
      <CriteriaDateRange className="form-element"
         {...(searchCriterais.dateRangeValue ?? searchCriterais.dateRangeDefault)}
         onChange={handleDateRangeChange}
      />

      <div className='form-element'>
        <button className="button is-primary" onClick={handleSubmit}>
          {t('Find a resort')}
        </button>
      </div>
    </form>
  );
}

export default SearchForm;

